import { render, staticRenderFns } from "./driver-details.vue?vue&type=template&id=566183f2&"
import script from "./driver-details.vue?vue&type=script&lang=js&"
export * from "./driver-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports